import React from "react";

function FooterComponent() {
  return (
    <div className="footer">
      <div className="footer__container">
        <div className="footer__up">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/Liga-Regional-Futbol-Rio-Cuarto-103875364507797"
          >
            <img src="/facebook.png" alt="" />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/ligafutbolriocuarto/"
          >
            <img src="/instagram.png" alt="" />
          </a>
        </div>
        <div className="footer__down">
          <h1 className="footer__rights">
            Liga Regional de Futbol de Río Cuarto | © Copyright{" "}
            {new Date().getFullYear()} | Todos los derechos Reservados
          </h1>
        </div>
      </div>
    </div>
  );
}

export default FooterComponent;
